module.exports = __webpack_public_path__ + "img/BB.798cd523.svg";